// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"928":"dc7b54b9b59cf011","13678":"57cb0da95d0342cc","36982":"4d6b1e618289a039","48846":"6438dbb375600f1b"}[chunkId] + ".css";
};